module.exports = __webpack_public_path__ + "img/ad1.198574f0.jpg";